/***
 *
 *   CATEGORY STATUS WORKFLOW
 *   Phase 6 — reference StatusWorkflowEditor chrome. Keeps live auto-save on
 *   cross-column drag (no explicit Save button).
 *
 **********/

import React from 'react';
import { Board } from './statuses/board/board';
import { useLiveQuery } from 'components/hooks/websocket';
import { useParams } from 'react-router-dom';
import { useProjectContext, Loader, Animate } from 'components/lib';
import { useMutation } from 'react-query';
import { useApiContext } from 'app/api';
import { useTranslate } from 'app/translations';
import Style from './ticketsCategoryStatus.tailwind';

const TicketsCategoryStatus = () => {
    const { id } = useParams();
    const { selectedProject } = useProjectContext();
    const { callApi } = useApiContext();
    const { _t } = useTranslate();

    const { data, isLoading } = useLiveQuery(
        'ticket_category',
        { id, project_id: selectedProject?.id },
        {
            enabled: !!selectedProject?.id && !!id,
        },
    );

    const statusTemplate = data ? data[0]?.status_template : [];

    const updateTicketStatus = async (status) => {
        const { data: res } = await callApi({
            method: 'PATCH',
            url: `/api/ticket/category/${id}`,
            data: {
                ...status,
                project_id: selectedProject?.id,
            },
        });
        return res;
    };

    const updateTicketStatusMutation = useMutation(updateTicketStatus);

    if (isLoading) {
        return <Loader />;
    }

    return (
        <Animate>
            <div className={Style.stack}>
                <p className={Style.hint}>{_t('ticket.category.status.dragHint')}</p>
                {statusTemplate && (
                    <Board
                        statusTemplate={statusTemplate}
                        updateTicketStatusMutation={updateTicketStatusMutation}
                    />
                )}
            </div>
        </Animate>
    );
};

export default TicketsCategoryStatus;
